import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './PasswordGate.css';

const { FiArrowRight, FiHeart } = FiIcons;
const SITE_PASSWORD = 'Herzschlag2027';

function PasswordGate({ children }) {
  const [password, setPassword] = useState('');
  const [unlocked, setUnlocked] = useState(false);
  const [error, setError] = useState('');

  function handleSubmit(event) {
    event.preventDefault();

    if (password === SITE_PASSWORD) {
      setUnlocked(true);
      setError('');
      return;
    }

    setError('Das Passwort stimmt nicht. Bitte erneut versuchen.');
  }

  if (unlocked) return children;

  return (
    <main className="password-gate">
      <section className="password-card" aria-labelledby="password-title">
        <div className="password-heart" aria-hidden="true">
          <SafeIcon icon={FiHeart} />
        </div>
        <span className="password-eyebrow">Herzschlag Hamburg · Brand Portal</span>
        <h1 id="password-title">Schön, dass du da bist.</h1>
        <p className="password-description">
          Dieses Brand Portal ist geschützt. Gib das Passwort ein, um
          fortzufahren.
        </p>
        <form className="password-form" onSubmit={handleSubmit}>
          <label htmlFor="site-password">Passwort</label>
          <input
            id="site-password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Passwort eingeben"
            autoComplete="current-password"
            aria-describedby={error ? 'password-error' : undefined}
            aria-invalid={Boolean(error)}
            autoFocus
          />
          {error && <p className="password-error" id="password-error">{error}</p>}
          <button type="submit">
            Zum Brand Portal <SafeIcon icon={FiArrowRight} />
          </button>
        </form>
        <span className="password-footer">Mit Liebe in Hamburg gestaltet</span>
      </section>
    </main>
  );
}

export default PasswordGate;